/* ==========================================================================
   Departments module — data layer.
   Faithful port of the prototype's org-structure rules:
   - a user belongs to exactly ONE department, but MANY units within it
   - roles are CALCULATED: head of a department -> Head of Department,
     head of a unit -> Head of Unit, everyone else -> Staff
   - approval routing is DERIVED from the structure (next two levels up),
     with per-department skip switches
   Persistence uses the same localStorage key as the prototype.
   ========================================================================== */

export const DEPARTMENTS_STORAGE_KEY = "besarawak_departments_v3";

export const DEFAULT_DEPARTMENTS = [
  {
    name: "CHIEF EXECUTIVE OFFICER OFFICE",
    description:
      "Executive leadership office overseeing strategy, governance, sustainability, audit, and integrity.",
    head: "Jason Tan Chin Foo",
    hasUnits: true,
    status: "Active",
    members: [
      { name: "Jason Tan Chin Foo", units: ["EXECUTIVE OFFICE"] },
      { name: "Candida Foo", units: ["EXECUTIVE OFFICE", "INTEGRITY"] },
      { name: "Isabella Perry", units: ["EXECUTIVE OFFICE"] },
      { name: "Syazwan", units: ["EXECUTIVE OFFICE"] },
      { name: "Serena Ong", units: ["LEGACY IMPACT & SUSTAINABILITY"] },
      { name: "Dayang Norasyifah Binti Awang Halil", units: ["LEGACY IMPACT & SUSTAINABILITY"] },
      { name: "Elisa Chai", units: ["INTERNAL AUDIT"] },
    ],
    units: [
      { name: "EXECUTIVE OFFICE", description: "Executive office support and coordination.", head: "Candida Foo", status: "Active" },
      { name: "LEGACY IMPACT & SUSTAINABILITY", description: "Legacy impact initiatives and sustainability programmes.", head: "Serena Ong", status: "Active" },
      { name: "INTERNAL AUDIT", description: "Internal audit governance and assurance.", head: "Elisa Chai", status: "Active" },
      { name: "INTEGRITY", description: "Integrity oversight and ethics administration.", head: "Candida Foo", status: "Active" },
    ],
  },
  {
    name: "CORPORATE MANAGEMENT",
    description: "Corporate management covering finance, human resource, and administration support.",
    head: "Jacqueline Ping",
    hasUnits: true,
    status: "Active",
    members: [
      { name: "Jacqueline Ping", units: [] },
      { name: "Erica Ng", units: ["Finance"] },
      { name: "Fam Kuek Chien", units: ["Finance"] },
      { name: "Nurashira Binti Muliadi", units: ["Finance"] },
      { name: "Lilyza Lagan", units: ["Finance"] },
      { name: "Sylvia Among", units: ["Finance"] },
      { name: "Chin Sin Nee", units: ["Human Resource"] },
      { name: "Nur Fatin Binti Ojek", units: ["Human Resource"] },
      { name: "Emily Bong", units: ["Administration"] },
      { name: "Nurin Jazlina", units: ["Administration"] },
      { name: "Alex Lidu", units: ["Administration"] },
    ],
    units: [
      { name: "Finance", description: "Finance and accounting operations.", head: "Erica Ng", status: "Active" },
      { name: "Human Resource", description: "Human resource administration and talent support.", head: "Chin Sin Nee", status: "Active" },
      { name: "Administration", description: "Office administration and general support services.", head: "Emily Bong", status: "Active" },
    ],
  },
  {
    name: "BUSINESS DEVELOPMENT & SERVICES",
    description:
      "Business development and services covering conventions, exhibitions, incentives, research, and bids.",
    head: "Andrea Kahar",
    hasUnits: true,
    status: "Active",
    members: [
      { name: "Andrea Kahar", units: [] },
      { name: "Denny Tan Yee Soon", units: ["Conventions"] },
      { name: "Stevenson Belawing", units: ["Conventions"] },
      { name: "Grace Ang Yixin", units: ["Conventions"] },
      { name: "Grace Valentina Robert", units: ["Conventions"] },
      { name: "Serena Sa-or", units: ["Exhibitions & Homegrown"] },
      { name: "Adrian Goh Sze Liang", units: ["Corporate meetings & Corporate incentives"] },
      { name: "Gloria Pahang", units: ["Corporate meetings & Corporate incentives"] },
      { name: "Azlin Peter", units: ["Administration"] },
      { name: "John Unbang Mauga", units: ["Research"] },
      { name: "Habibah Liza Balan", units: ["Research"] },
      { name: "Nur Hayza Binti Hamdan", units: ["Research"] },
      { name: "Christynn Siaw", units: ["BIDS"] },
      { name: "Alexandra Sijau", units: ["BIDS"] },
      { name: "Edna Emily Suriati Binti Gapor", units: ["BIDS"] },
      { name: "Dayang Adhwa' Tasnim", units: ["BIDS"] },
    ],
    units: [
      { name: "Conventions", description: "Convention business development and servicing.", head: "Denny Tan Yee Soon", status: "Active" },
      { name: "Exhibitions & Homegrown", description: "Exhibitions and homegrown event development.", head: "Serena S/O", status: "Active" },
      { name: "Corporate meetings & Corporate incentives", description: "Corporate meetings and incentive business development.", head: "Lairi Loh Sze Ooi", status: "Active" },
      { name: "Administration", description: "Administrative coordination for business development teams.", head: "Azlin Peter", status: "Active" },
      { name: "Research", description: "Research, market insight, and analysis support.", head: "John Unbang Mauga", status: "Active" },
      { name: "BIDS", description: "Bid strategy, proposal support, and client servicing.", head: "Christyn Siaw", status: "Active" },
    ],
  },
  {
    name: "CAPACITY & DIGITALISATION",
    description: "Capacity building, project compliance, and digitalisation initiatives.",
    head: "Joachim Soon",
    hasUnits: true,
    status: "Active",
    members: [
      { name: "Joachim Soon", units: [] },
      { name: "Bibi Alijah @ Nurannma Rozaman", units: ["GOVERNMENT RELATIONS & PROJECT COMPLIANCE"] },
      { name: "Myla Aron", units: ["GOVERNMENT RELATIONS & PROJECT COMPLIANCE"] },
      { name: "Anne Aren Thomas", units: ["GOVERNMENT RELATIONS & PROJECT COMPLIANCE"] },
      { name: "Aljjal Sienia", units: ["GOVERNMENT RELATIONS & PROJECT COMPLIANCE"] },
      { name: "Ellya Emelda Rochellow", units: ["CAPACITY BUILDING"] },
      { name: "Effia Senas", units: ["MARKET INTELLIGENCE"] },
      { name: "Nurul Shahiha Ismail", units: ["MARKET INTELLIGENCE"] },
      { name: "Beatrice Stella", units: ["MARKET INTELLIGENCE"] },
      { name: "Alistair Lorenzo James", units: ["DIGITALISATION"] },
      { name: "Eric Wee", units: ["DIGITALISATION"] },
      { name: "Muhamad Khairul Aizuddin", units: ["DIGITALISATION"] },
    ],
    units: [
      { name: "GOVERNMENT RELATIONS & PROJECT COMPLIANCE", description: "Government relations and project compliance support.", head: "Bibi Alijah @ Nurannma Rozaman", status: "Active" },
      { name: "CAPACITY BUILDING", description: "Capacity building programmes and professional development.", head: "Ellya Emelda Rochellow", status: "Active" },
      { name: "MARKET INTELLIGENCE", description: "Market intelligence, research, and industry insight.", head: "Effia Senas", status: "Active" },
      { name: "DIGITALISATION", description: "Digital development, ICT, and organisational digitalisation.", head: "Alistair Lorenzo James", status: "Active" },
    ],
  },
  {
    name: "MARKETING & COMMUNICATIONS",
    description: "Strategic marketing, communications, branding, and campaign execution.",
    head: "Rose Bruce",
    hasUnits: false,
    status: "Active",
    members: [
      { name: "Rose Bruce", units: [] },
      { name: "Gary Chan", units: [] },
      { name: "Verlena Tan", units: [] },
      { name: "Shaifullah Naim", units: [] },
      { name: "Norul Huda", units: [] },
    ],
    units: [],
  },
];

const GENERAL_MANAGER_NAMES = ["Jason Tan Chin Foo", "Jacqueline Ping", "Andrea Kahar", "Joachim Soon", "Rose Bruce"];
const HEAD_OF_UNIT_NAMES = [
  "Candida Foo", "Serena Ong", "Elisa Chai", "Erica Ng", "Chin Sin Nee", "Emily Bong",
  "Denny Tan Yee Soon", "Serena Sa-or", "Adrian Goh Sze Liang", "Azlin Peter", "John Unbang Mauga",
  "Christynn Siaw", "Bibi Alijah @ Nurannma Rozaman", "Ellya Emelda Rochellow", "Effia Senas",
  "Alistair Lorenzo James",
];

const toEmail = (name) =>
  `${name.toLowerCase().replace(/[^a-z]+/g, ".").replace(/^\.|\.$/g, "")}@besarawak.com`;

export const ORGANISATION_USERS = [
  ...GENERAL_MANAGER_NAMES.map((name) => ({ name, email: toEmail(name) })),
  ...HEAD_OF_UNIT_NAMES.map((name) => ({ name, email: toEmail(name) })),
  ...Array.from(new Set(DEFAULT_DEPARTMENTS.flatMap((department) =>
    department.members.map((member) => member.name)
  )))
    .filter((name) => !GENERAL_MANAGER_NAMES.includes(name) && !HEAD_OF_UNIT_NAMES.includes(name))
    .map((name) => ({ name, email: toEmail(name) })),
];

export const clone = (data) => JSON.parse(JSON.stringify(data));

/* One department per user; member.units limited to real unit names. */
export const normalizeDepartments = (departments) => {
  const assignedElsewhere = new Set();
  departments.forEach((department) => {
    if (!Array.isArray(department.members)) department.members = [];
    if (!Array.isArray(department.units)) department.units = [];
    const unitNames = department.units.map((unit) => unit.name);
    department.units.forEach((unit) => {
      if (Array.isArray(unit.members) && unit.members.length) {
        unit.members.forEach((member) => {
          const existing = department.members.find((item) => item.name === member.name);
          if (existing) {
            existing.units = Array.from(new Set([...(existing.units || []), unit.name]));
          } else {
            department.members.push({ name: member.name, email: member.email || "", units: [unit.name] });
          }
        });
      }
      delete unit.members;
    });
    department.members = department.members.filter((member) => {
      if (assignedElsewhere.has(member.name)) return false;
      assignedElsewhere.add(member.name);
      member.units = (member.units || []).filter((name) => unitNames.includes(name));
      return true;
    });
  });
  return departments;
};

export const loadDepartments = () => {
  try {
    const raw = window.localStorage.getItem(DEPARTMENTS_STORAGE_KEY);
    if (!raw) {
      const defaults = clone(DEFAULT_DEPARTMENTS);
      window.localStorage.setItem(DEPARTMENTS_STORAGE_KEY, JSON.stringify(defaults));
      return defaults;
    }
    const parsed = JSON.parse(raw);
    if (!Array.isArray(parsed)) throw new Error("Invalid department store");
    return normalizeDepartments(parsed);
  } catch (error) {
    return clone(DEFAULT_DEPARTMENTS);
  }
};

export const saveDepartments = (departments) => {
  try {
    window.localStorage.setItem(DEPARTMENTS_STORAGE_KEY, JSON.stringify(departments));
  } catch (error) {
    /* best effort */
  }
};

/* Role is CALCULATED from the structure, never assigned directly. */
export const computeUserRole = (userName, departments) => {
  let role = "Staff";
  departments.forEach((department) => {
    if (department.head === userName) role = "Head of Department";
    (department.units || []).forEach((unit) => {
      if (unit.head === userName && role === "Staff") role = "Head of Unit";
    });
  });
  return role;
};

export const getDepartmentByUserMap = (departments) => {
  const map = new Map();
  departments.forEach((department) => {
    (department.members || []).forEach((member) => {
      if (!map.has(member.name)) map.set(member.name, department.name);
    });
  });
  return map;
};

export const getCeoOfficeHead = (departments) => {
  const ceoOffice = departments.find((department) => /chief executive|ceo/i.test(department.name));
  return (ceoOffice && ceoOffice.head) || "";
};

/* Approvers = next two levels up, minus skipped layers; the same person never
   appears twice; nobody approves their own request. */
export const buildApprovalRows = (department, departments) => {
  if (!department) return [];
  const skips = department.approvalSkips || {};
  const isCeoOffice = /chief executive|ceo/i.test(department.name);
  const ceoName = getCeoOfficeHead(departments);

  const AUTO = { type: "auto", label: "Auto-approved — layer skipped" };
  const TOP = { type: "top", label: "Top of structure — no higher approver" };
  const NONE = { type: "none", label: "—" };

  const person = (name, tag) => ({ type: "person", label: name, tag: tag || "" });
  const unassigned = (role) => ({ type: "unassigned", label: `${role} (unassigned)` });

  const departmentHeadCandidate = {
    rawName: department.head || "",
    cell: department.head ? person(department.head) : unassigned("Head of Department"),
    skipped: !!skips.departmentHead,
  };
  const ceoCandidate = {
    rawName: ceoName || "",
    cell: ceoName ? person(ceoName, "CEO Office") : unassigned("CEO"),
    skipped: !!skips.ceo,
  };

  const buildChain = (candidates, applicantName = "", emptyCell = AUTO) => {
    const seen = new Set();
    const approvers = [];
    candidates.forEach((candidate) => {
      if (candidate.skipped) return;
      if (candidate.rawName) {
        if (candidate.rawName === applicantName || seen.has(candidate.rawName)) return;
        seen.add(candidate.rawName);
      }
      approvers.push(candidate.cell);
    });
    return { first: approvers[0] || emptyCell, second: approvers[1] || NONE };
  };

  const rows = [];
  if (department.hasUnits && (department.units || []).length) {
    department.units.forEach((unit) => {
      rows.push({
        applicant: `Staff — ${unit.name}`,
        ...buildChain([
          { rawName: unit.head || "", cell: unit.head ? person(unit.head) : unassigned("Head of Unit"), skipped: !!skips.unitHead },
          departmentHeadCandidate,
          ceoCandidate,
        ]),
      });
    });
    rows.push({ applicant: "Head of Unit (any unit)", ...buildChain([departmentHeadCandidate, ceoCandidate]) });
  } else {
    rows.push({ applicant: "Staff", ...buildChain([departmentHeadCandidate, ceoCandidate]) });
  }

  const headEmptyCell = skips.ceo
    ? AUTO
    : isCeoOffice || (department.head && department.head === ceoName)
      ? TOP
      : AUTO;
  rows.push({
    applicant: `Head of Department${department.head ? ` — ${department.head}` : ""}`,
    ...buildChain([ceoCandidate], department.head || "", headEmptyCell),
  });

  return rows;
};

export const getInitials = (name) =>
  name
    .split(" ")
    .map((part) => part[0])
    .join("")
    .substring(0, 2)
    .toUpperCase() || "U";
